/* eslint-disable linebreak-style */
export default {
    root: {
      borderRadius: 28
    }
};
